export default {
      id: "icon-eye-usage",
      viewBox: "0 1 16 17",
      url: "/" + "assets/sprite.svg#icon-eye",
      toString: function () {
        return this.url;
      }
    }